<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="9">
      <h1>Статистика по дням</h1>
    </v-col>
    <v-col cols="3">
    </v-col>
    <v-col cols="12" sm="12">
      <v-data-table
          no-data-text="Нет записей"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :items="statistics"
          :search="search"
          :options.sync="options"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :fixed-header="true"
          height="61vh"
          :footer-props="footerProps"
          :loading="loading"
          :items-per-page="-1"
          loading-text="Загрузка... Подождите пожалуйста"
      >
        <template v-slot:item.file="{item, index}">
          {{ item }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="download(item)">
                  <v-list-item-title>Скачать</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import PayInvoiceService from './../../api/PayInvoiceService'
import OnlinePayAccountService from './../../api/OnlinePayAccountService'
export default {
  name: 'DayStatsIndex',
  components: {},
  data: () => ({
    statistics: [],
    overlay: false,
    search: '',
    loading: true,
    options: {},
    footerProps: {
      itemsPerPageText: 'Записей на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [-1]
    },
    headers: [
      {
        text: 'Файл',
        value: 'file',
        sortable: false,
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
      },
    ],
  }),
  mounted() {
    this.getDataFromApi()
  },
  watch: {
  },
  methods: {
    download(file) {
      PayInvoiceService.downloadStatisticsFile(file)
          .then(response => {
            const type = response.headers['content-type']
            const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'file.xlsx'
            link.click()
          })
    },
    getDataFromApi() {
      this.loading = true

      PayInvoiceService.getListOfStatisticsFile()
          .then(response => {
            this.statistics = response.data
            this.loading = false
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }

  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
